module.exports = __webpack_public_path__ + "static/zama_libertad_sintesis-e7d8c2ae9be54b6e70c012c59b1cd6f4.jpg";